import { useEffect, RefObject } from 'react';

export function useSwipeGesture(
  ref: RefObject<HTMLElement>,
  onNext: () => void,
  onPrev: () => void,
) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let startX = 0;

    const onTouchStart = (e: TouchEvent) => {
      startX = e.touches[0]?.clientX ?? 0;
    };

    const onTouchEnd = (e: TouchEvent) => {
      const endX = e.changedTouches[0]?.clientX ?? startX;
      const delta = startX - endX;
      if (Math.abs(delta) < 50) return;
      if (delta > 0) onNext();
      else onPrev();
    };

    el.addEventListener('touchstart', onTouchStart, { passive: true });
    el.addEventListener('touchend', onTouchEnd, { passive: true });
    return () => {
      el.removeEventListener('touchstart', onTouchStart);
      el.removeEventListener('touchend', onTouchEnd);
    };
  }, [ref, onNext, onPrev]);
}
